export default {
  gallerySelectorHeight: 90
};
